<template>

  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Crear Usuario</p>
              <argon-button color="success" size="sm" class="ms-auto" @click="save" :disabled="isSaving">Guardar</argon-button>
            </div>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-sm">Información</p>
            <div class="row">
              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Nombre</label>
                <argon-input type="text" v-model="user.name" />
              </div>
              <div class="col-md-6">
                <label for="document-type" class="form-control-label">Tipo de Documento</label>
                <select id="documentType" class="form-control" v-model="user.document_type">
                  <option value="" disabled>Seleccione un tipo de documento</option>
                  <option value="CC">Cédula de Ciudadanía (CC)</option>
                  <option value="CE">Cédula de Extranjería (CE)</option>
                  <option value="TI">Tarjeta de Identidad (TI)</option>
                  <option value="RC">Registro Civil (RC)</option>
                  <option value="PA">Pasaporte (PA)</option>
                  <option value="PEP">Permiso Especial de Permanencia (PEP)</option>
                  <option value="NIT">Número de Identificación Tributaria (NIT)</option>
                </select>
              </div>
              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Número documento</label>
                <argon-input type="text" v-model="user.document" autocomplete="off" />
              </div>

              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Dirección</label>
                <argon-input type="text" v-model="user.address" autocomplete="off" />
              </div>

              <div class="col-md-4">
                <label for="province-select" class="form-control-label">Departamento</label>
                <select id="province-select" class="form-select" v-model="user.province" @change="onProvinceChange">
                  <option value="" disabled>Seleccione un departamento</option>
                  <option v-for="dept in departments" :key="dept.code" :value="dept.name">
                    {{ dept.name }}
                  </option>
                </select>
              </div>

              <div class="col-md-4">
                <label for="city-select" class="form-control-label">Ciudad / Municipio</label>
                <select id="city-select" class="form-select" v-model="user.city" :disabled="!user.province">
                  <option value="" disabled>Seleccione una ciudad</option>
                  <option v-for="city in availableCities" :key="city" :value="city">
                    {{ city }}
                  </option>
                </select>
              </div>

              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Código Postal</label>
                <argon-input type="text" v-model="user.zip" autocomplete="off" placeholder="Opcional" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Teléfono</label>
                <argon-input type="text" v-model="user.phone" autocomplete="off" />
              </div>
              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Correo electrónico</label>
                <argon-input type="email" v-model="user.email" autocomplete="off" />
              </div>

              

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Contraseña</label>
                <argon-input type="password" v-model="user.password" autocomplete="off" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Confirmar Contraseña</label>
                <argon-input type="password" v-model="user.password_confirmation" autocomplete="off" />
              </div>

              <hr class="my-4">


              
              <div class="col-md-12 my-3">
                <label for="processes-checkbox-list" class="form-control-label">Procesos</label>
                <div id="processes-checkbox-list" class="checkbox-grid">
                  <div v-for="process in processes" :key="process.id">
                    <argon-checkbox :id="'process-' + process.id" :value="process.id"
                      :checked="user.processes.includes(process.id)" v-model="user.processes">
                      {{ process.name }}
                    </argon-checkbox>
                  </div>

                </div>
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Forma de pago</label>
                <select name="" id="role" class="form-select" v-model="user.payment">
                  <option value="0">Mensualidad</option>
                  <option value="1">Por Tarea</option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Cargo</label>
                <select name="" id="role" class="form-select" v-model="user.role">
                  <option value="1">Administrador</option>
                  <option value="2">Supervisor</option>
                  <option value="3">Operario</option>
                  <option value="4">Cliente</option>
                  <option value="5">Proveedor</option>
                </select>
              </div>

              

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Estado</label>
                <select name="" id="status" class="form-select" v-model="user.status">
                  <option value="1">Activo</option>
                  <option value="0">Inactivo</option>
                </select>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- Columna derecha: permisos de módulos para supervisor -->
      <div class="col-md-4" v-if="isSupervisor">
        <div class="card">
          <div class="card-header pb-0">
            <p class="mb-0 text-sm font-weight-bold">Módulos visibles para el supervisor</p>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-xs text-secondary mb-3">Activar los módulos que puede ver</p>
            <div id="supervisor-modules-checkbox-list" class="checkbox-list-single">
              <div v-for="mod in supervisorModulesList" :key="mod.id">
                <argon-checkbox
                  :id="'mod-' + mod.id"
                  :value="mod.id"
                  :checked="user.supervisor_modules.includes(mod.id)"
                  v-model="user.supervisor_modules">
                  {{ mod.name }}
                </argon-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<style scoped>
.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
.checkbox-list-single {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
</style>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import ArgonCheckbox from "../../../components/ArgonCheckbox.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import $ from 'jquery';

const body = document.getElementsByTagName("body")[0];


export default {
  name: "User Create",
  data() {
    return {
      showMenu: false,
      isSaving: false,
      user: {
        id: 0,
        name: '',
        document_type: '',
        document: '',
        address: '',
        province: '',
        city: '',
        zip: '',
        email: '',
        password: '',
        password_confirmation: '',
        role: '1',
        status: '1',
        phone: '',
        payment: '0',
        processes: [],
        supervisor_modules: [],
      },
      processes: [],
      departments: [
        { code: 'AMA', name: 'Amazonas', cities: ['Leticia', 'Puerto Nariño', 'El Encanto', 'La Chorrera', 'La Pedrera', 'La Victoria', 'Miriti-Paraná', 'Puerto Alegría', 'Puerto Arica', 'Puerto Santander', 'Tarapacá'] },
        { code: 'ANT', name: 'Antioquia', cities: ['Abejorral', 'Abriaquí', 'Alejandría', 'Amagá', 'Amalfi', 'Andes', 'Angelópolis', 'Angostura', 'Anorí', 'Anzá', 'Apartadó', 'Arboletes', 'Argelia', 'Armenia', 'Barbosa', 'Bello', 'Belmira', 'Betania', 'Betulia', 'Briceño', 'Buriticá', 'Cáceres', 'Caicedo', 'Caldas', 'Campamento', 'Cañasgordas', 'Caracolí', 'Caramanta', 'Carepa', 'Carolina del Príncipe', 'Caucasia', 'Chigorodó', 'Cisneros', 'Ciudad Bolívar', 'Cocorná', 'Concepción', 'Concordia', 'Copacabana', 'Dabeiba', 'Donmatías', 'Ebéjico', 'El Bagre', 'El Carmen de Viboral', 'El Peñol', 'El Retiro', 'El Santuario', 'Entrerríos', 'Envigado', 'Fredonia', 'Frontino', 'Giraldo', 'Girardota', 'Gómez Plata', 'Granada', 'Guadalupe', 'Guarne', 'Guatapé', 'Heliconia', 'Hispania', 'Itagüí', 'Ituango', 'Jardín', 'Jericó', 'La Ceja', 'La Estrella', 'La Pintada', 'La Unión', 'Liborina', 'Maceo', 'Marinilla', 'Medellín', 'Montebello', 'Murindó', 'Mutatá', 'Nariño', 'Nechí', 'Necoclí', 'Olaya', 'Peque', 'Pueblorrico', 'Puerto Berrío', 'Puerto Nare', 'Puerto Triunfo', 'Remedios', 'Rionegro', 'Sabanalarga', 'Sabaneta', 'Salgar', 'San Andrés de Cuerquia', 'San Carlos', 'San Francisco', 'San Jerónimo', 'San José de la Montaña', 'San Juan de Urabá', 'San Luis', 'San Pedro de Urabá', 'San Pedro de los Milagros', 'San Rafael', 'San Roque', 'San Vicente', 'Santa Bárbara', 'Santa Fe de Antioquia', 'Santa Rosa de Osos', 'Santo Domingo', 'Segovia', 'Sonsón', 'Sopetrán', 'Támesis', 'Tarazá', 'Tarso', 'Titiribí', 'Toledo', 'Turbo', 'Uramita', 'Urrao', 'Valdivia', 'Valparaíso', 'Vegachí', 'Venecia', 'Vigía del Fuerte', 'Yalí', 'Yarumal', 'Yolombó', 'Yondó', 'Zaragoza'] },
        { code: 'ARU', name: 'Arauca', cities: ['Arauca', 'Arauquita', 'Cravo Norte', 'Fortul', 'Puerto Rondón', 'Saravena', 'Tame'] },
        { code: 'ATL', name: 'Atlántico', cities: ['Baranoa', 'Barranquilla', 'Campo de la Cruz', 'Candelaria', 'Galapa', 'Juan de Acosta', 'Luruaco', 'Malambo', 'Manatí', 'Palmar de Varela', 'Piojó', 'Polonuevo', 'Ponedera', 'Puerto Colombia', 'Repelón', 'Sabanagrande', 'Sabanalarga', 'Santa Lucía', 'Santo Tomás', 'Soledad', 'Suán', 'Tubará', 'Usiacurí'] },
        { code: 'BOG', name: 'Bogotá D.C.', cities: ['Bogotá'] },
        { code: 'BOL', name: 'Bolívar', cities: ['Achí', 'Altos del Rosario', 'Arenal', 'Arjona', 'Arroyohondo', 'Barranco de Loba', 'Brazuelo de Papayal', 'Calamar', 'Cantagallo', 'Cartagena de Indias', 'Cicuco', 'Clemencia', 'Córdoba', 'El Carmen de Bolívar', 'El Guamo', 'El Peñón', 'Hatillo de Loba', 'Magangué', 'Mahates', 'Margarita', 'María la Baja', 'Mompós', 'Montecristo', 'Morales', 'Norosí', 'Pinillos', 'Regidor', 'Río Viejo', 'San Cristóbal', 'San Estanislao', 'San Fernando', 'San Jacinto del Cauca', 'San Jacinto', 'San Juan Nepomuceno', 'San Martín de Loba', 'San Pablo', 'Santa Catalina', 'Santa Rosa', 'Santa Rosa del Sur', 'Simití', 'Soplaviento', 'Talaigua Nuevo', 'Tiquisio', 'Turbaco', 'Turbaná', 'Villanueva', 'Zambrano'] },
        { code: 'BOY', name: 'Boyacá', cities: ['Almeida', 'Aquitania', 'Arcabuco', 'Belén', 'Berbeo', 'Betéitiva', 'Boavita', 'Boyacá', 'Briceño', 'Buenavista', 'Busbanzá', 'Caldas', 'Campohermoso', 'Cerinza', 'Chinavita', 'Chiquinquirá', 'Chíquiza', 'Chiscas', 'Chita', 'Chitaraque', 'Chivatá', 'Chivor', 'Ciénega', 'Cómbita', 'Coper', 'Corrales', 'Covarachía', 'Cubará', 'Cucaita', 'Cuítiva', 'Duitama', 'El Cocuy', 'El Espino', 'Firavitoba', 'Floresta', 'Gachantivá', 'Gámeza', 'Garagoa', 'Guacamayas', 'Guateque', 'Guayatá', 'Güicán', 'Iza', 'Jenesano', 'Jericó', 'La Capilla', 'La Uvita', 'La Victoria', 'Labranzagrande', 'Macanal', 'Maripí', 'Miraflores', 'Mongua', 'Monguí', 'Moniquirá', 'Motavita', 'Muzo', 'Nobsa', 'Nuevo Colón', 'Oicatá', 'Otanche', 'Pachavita', 'Páez', 'Paipa', 'Pajarito', 'Panqueba', 'Pauna', 'Paya', 'Paz del Río', 'Pesca', 'Pisba', 'Puerto Boyacá', 'Quípama', 'Ramiriquí', 'Ráquira', 'Rondón', 'Saboyá', 'Sáchica', 'Samacá', 'San Eduardo', 'San José de Pare', 'San Luis de Gaceno', 'San Mateo', 'San Miguel de Sema', 'San Pablo de Borbur', 'Santa María', 'Santa Rosa de Viterbo', 'Santa Sofía', 'Santana', 'Sativanorte', 'Sativasur', 'Siachoque', 'Soatá', 'Socha', 'Socotá', 'Sogamoso', 'Somondoco', 'Sora', 'Soracá', 'Sotaquirá', 'Susacón', 'Sutamarchán', 'Sutatenza', 'Tasco', 'Tenza', 'Tibaná', 'Tibasosa', 'Tinjacá', 'Tipacoque', 'Toca', 'Togüí', 'Tópaga', 'Tota', 'Tunja', 'Tununguá', 'Turmequé', 'Tuta', 'Tutazá', 'Úmbita', 'Ventaquemada', 'Villa de Leyva', 'Viracachá', 'Zetaquira'] },
        { code: 'CAL', name: 'Caldas', cities: ['Aguadas', 'Anserma', 'Aranzazu', 'Belalcázar', 'Chinchiná', 'Filadelfia', 'La Dorada', 'La Merced', 'Manizales', 'Manzanares', 'Marmato', 'Marquetalia', 'Marulanda', 'Neira', 'Norcasia', 'Pácora', 'Palestina', 'Pensilvania', 'Riosucio', 'Risaralda', 'Salamina', 'Samaná', 'San José', 'Supía', 'Victoria', 'Villamaría', 'Viterbo'] },
        { code: 'CAQ', name: 'Caquetá', cities: ['Albania', 'Belén de los Andaquíes', 'Cartagena del Chairá', 'Curillo', 'El Doncello', 'El Paujil', 'Florencia', 'La Montañita', 'Milán', 'Morelia', 'Puerto Rico', 'San José del Fragua', 'San Vicente del Caguán', 'Solano', 'Solita', 'Valparaíso'] },
        { code: 'CAS', name: 'Casanare', cities: ['Aguazul', 'Chámeza', 'Hato Corozal', 'La Salina', 'Maní', 'Monterrey', 'Nunchía', 'Orocué', 'Paz de Ariporo', 'Pore', 'Recetor', 'Sabanalarga', 'Sácama', 'San Luis de Palenque', 'Támara', 'Tauramena', 'Trinidad', 'Villanueva', 'Yopal'] },
        { code: 'CAU', name: 'Cauca', cities: ['Almaguer', 'Argelia', 'Balboa', 'Bolívar', 'Buenos Aires', 'Cajibío', 'Caldono', 'Caloto', 'Corinto', 'El Tambo', 'Florencia', 'Guachené', 'Guapí', 'Inzá', 'Jambaló', 'La Sierra', 'La Vega', 'López de Micay', 'Mercaderes', 'Miranda', 'Morales', 'Padilla', 'Páez', 'Patía', 'Piamonte', 'Piendamó', 'Popayán', 'Puerto Tejada', 'Puracé', 'Rosas', 'San Sebastián', 'Santa Rosa', 'Santander de Quilichao', 'Silvia', 'Sotará', 'Suárez', 'Sucre', 'Timbío', 'Timbiquí', 'Toribío', 'Totoró', 'Villa Rica'] },
        { code: 'CES', name: 'Cesar', cities: ['Aguachica', 'Agustín Codazzi', 'Astrea', 'Becerril', 'Bosconia', 'Chimichagua', 'Chiriguaná', 'Curumaní', 'El Copey', 'El Paso', 'Gamarra', 'González', 'La Gloria (Cesar)', 'La Jagua de Ibirico', 'La Paz', 'Manaure Balcón del Cesar', 'Pailitas', 'Pelaya', 'Pueblo Bello', 'Río de Oro', 'San Alberto', 'San Diego', 'San Martín', 'Tamalameque', 'Valledupar'] },
        { code: 'CHO', name: 'Chocó', cities: ['Acandí', 'Alto Baudó', 'Bagadó', 'Bahía Solano', 'Bajo Baudó', 'Bojayá', 'Cantón de San Pablo', 'Cértegui', 'Condoto', 'El Atrato', 'El Carmen de Atrato', 'El Carmen del Darién', 'Istmina', 'Juradó', 'Litoral de San Juan', 'Lloró', 'Medio Atrato', 'Medio Baudó', 'Medio San Juan', 'Nóvita', 'Nuquí', 'Quibdó', 'Río Iró', 'Río Quito', 'Riosucio', 'San José del Palmar', 'Sipí', 'Tadó', 'Unión Panamericana', 'Unguía', 'Nuevo Belén de Bajirá'] },
        { code: 'COR', name: 'Córdoba', cities: ['Ayapel', 'Buenavista', 'Canalete', 'Cereté', 'Chimá', 'Chinú', 'Ciénaga de Oro', 'Cotorra', 'La Apartada', 'Lorica', 'Los Córdobas', 'Momil', 'Montelíbano', 'Montería', 'Moñitos', 'Planeta Rica', 'Pueblo Nuevo', 'Puerto Escondido', 'Puerto Libertador', 'Purísima', 'Sahagún', 'San Andrés de Sotavento', 'San Antero', 'San Bernardo del Viento', 'San Carlos', 'San José de Uré', 'San Pelayo', 'Tierralta', 'Tuchín', 'Valencia'] },
        { code: 'CUN', name: 'Cundinamarca', cities: ['Agua de Dios', 'Albán', 'Anapoima', 'Anolaima', 'Apulo', 'Arbeláez', 'Beltrán', 'Bituima', 'Bojacá', 'Cabrera', 'Cachipay', 'Cajicá', 'Caparrapí', 'Cáqueza', 'Carmen de Carupa', 'Chaguaní', 'Chía', 'Chipaque', 'Choachí', 'Chocontá', 'Cogua', 'Cota', 'Cucunubá', 'El Colegio', 'El Peñón', 'El Rosal', 'Facatativá', 'Fómeque', 'Fosca', 'Funza', 'Fúquene', 'Fusagasugá', 'Gachalá', 'Gachancipá', 'Gachetá', 'Gama', 'Girardot', 'Granada', 'Guachetá', 'Guaduas', 'Guasca', 'Guataquí', 'Guatavita', 'Guayabal de Síquima', 'Guayabetal', 'Gutiérrez', 'Jerusalén', 'Junín', 'La Calera', 'La Mesa', 'La Palma', 'La Peña', 'La Vega', 'Lenguazaque', 'Machetá', 'Madrid', 'Manta', 'Medina', 'Mosquera', 'Nariño', 'Nemocón', 'Nilo', 'Nimaima', 'Nocaima', 'Pacho', 'Paime', 'Pandi', 'Paratebueno', 'Pasca', 'Puerto Salgar', 'Pulí', 'Quebradanegra', 'Quetame', 'Quipile', 'Ricaurte', 'San Antonio del Tequendama', 'San Bernardo', 'San Cayetano', 'San Francisco', 'San Juan de Rioseco', 'Sasaima', 'Sesquilé', 'Sibaté', 'Silvania', 'Simijaca', 'Soacha', 'Sopó', 'Subachoque', 'Suesca', 'Supatá', 'Susa', 'Sutatausa', 'Tabio', 'Tausa', 'Tena', 'Tenjo', 'Tibacuy', 'Tibirita', 'Tocaima', 'Tocancipá', 'Topaipí', 'Ubalá', 'Ubaque', 'Ubaté', 'Une', 'Útica', 'Venecia', 'Vergara', 'Vianí', 'Villagómez', 'Villapinzón', 'Villeta', 'Viotá', 'Yacopí', 'Zipacón', 'Zipaquirá'] },
        { code: 'GUA', name: 'Guainía', cities: ['Inírida', 'Barranco Minas', 'Mapiripana', 'San Felipe', 'Puerto Colombia', 'La Guadalupe', 'Cacahual', 'Pana Pana', 'Morichal'] },
        { code: 'GUV', name: 'Guaviare', cities: ['Calamar', 'El Retorno', 'Miraflores', 'San José del Guaviare', 'San Joaquín', 'La Macarena'] },
        { code: 'HUI', name: 'Huila', cities: ['Acevedo', 'Agrado', 'Aipe', 'Algeciras', 'Altamira', 'Baraya', 'Campoalegre', 'Colombia', 'El Pital', 'Elías', 'Garzón', 'Gigante', 'Guadalupe', 'Hobo', 'Íquira', 'Isnos', 'La Argentina', 'La Plata', 'Nátaga', 'Neiva', 'Oporapa', 'Paicol', 'Palermo', 'Palestina', 'Pitalito', 'Rivera', 'Saladoblanco', 'San Agustín', 'Santa María', 'Suaza', 'Tarqui', 'Tello', 'Teruel', 'Tesalia', 'Timaná', 'Villavieja', 'Yaguará'] },
        { code: 'LAG', name: 'La Guajira', cities: ['Albania', 'Barrancas', 'Dibulla', 'Distracción', 'El Molino', 'Fonseca', 'Hatonuevo', 'La Jagua del Pilar', 'Maicao', 'Manaure', 'Riohacha', 'San Juan del Cesar', 'Uribia', 'Urumita', 'Villanueva'] },
        { code: 'MAG', name: 'Magdalena', cities: ['Algarrobo', 'Aracataca', 'Ariguaní', 'Cerro de San Antonio', 'Chibolo', 'Ciénaga', 'Concordia', 'El Banco', 'El Piñón', 'El Retén', 'Fundación', 'Guamal', 'Nueva Granada', 'Pedraza', 'Pijiño del Carmen', 'Pivijay', 'Plato', 'Pueblo Viejo', 'Remolino', 'Sabanas de San Ángel', 'Salamina', 'San Sebastián de Buenavista', 'San Zenón', 'Santa Ana', 'Santa Bárbara de Pinto', 'Santa Marta', 'Sitionuevo', 'Tenerife', 'Zapayán', 'Zona Bananera'] },
        { code: 'MET', name: 'Meta', cities: ['Acacías', 'Barranca de Upía', 'Cabuyaro', 'Castilla la Nueva', 'Cubarral', 'Cumaral', 'El Calvario', 'El Castillo', 'El Dorado', 'Fuente de Oro', 'Granada', 'Guamal', 'La Macarena', 'La Uribe', 'Lejanías', 'Mapiripán', 'Mesetas', 'Puerto Concordia', 'Puerto Gaitán', 'Puerto Lleras', 'Puerto López', 'Puerto Rico', 'Restrepo', 'San Carlos de Guaroa', 'San Juan de Arama', 'San Juanito', 'San Martín', 'Villavicencio', 'Vista Hermosa'] },
        { code: 'NAR', name: 'Nariño', cities: ['Aldana', 'Ancuyá', 'Arboleda', 'Barbacoas', 'Belén', 'Buesaco', 'Chachagüí', 'Colón', 'Consacá', 'Contadero', 'Córdoba', 'Cuaspud', 'Cumbal', 'Cumbitara', 'El Charco', 'El Peñol', 'El Rosario', 'El Tablón', 'El Tambo', 'Francisco Pizarro', 'Funes', 'Guachucal', 'Guaitarilla', 'Gualmatán', 'Iles', 'Imués', 'Ipiales', 'La Cruz', 'La Florida', 'La Llanada', 'La Tola', 'La Unión', 'Leiva', 'Linares', 'Los Andes', 'Magüí Payán', 'Mallama', 'Mosquera', 'Nariño', 'Olaya Herrera', 'Ospina', 'Pasto', 'Policarpa', 'Potosí', 'Providencia', 'Puerres', 'Pupiales', 'Ricaurte', 'Roberto Payán', 'Samaniego', 'San Bernardo', 'San José de Albán', 'San Lorenzo', 'San Pablo', 'San Pedro de Cartago', 'Sandoná', 'Santa Bárbara', 'Santacruz', 'Sapuyes', 'Taminango', 'Tangua', 'Tumaco', 'Túquerres', 'Yacuanquer'] },
        { code: 'NSA', name: 'Norte de Santander', cities: ['Ábrego', 'Arboledas', 'Bochalema', 'Bucarasica', 'Cáchira', 'Cácota', 'Chinácota', 'Chitagá', 'Convención', 'Cúcuta', 'Cucutilla', 'Duranía', 'El Carmen', 'El Tarra', 'El Zulia', 'Gramalote', 'Hacarí', 'Herrán', 'La Esperanza', 'La Playa de Belén', 'Labateca', 'Los Patios', 'Lourdes', 'Mutiscua', 'Ocaña', 'Pamplona', 'Pamplonita', 'Puerto Santander', 'Ragonvalia', 'Salazar de Las Palmas', 'San Calixto', 'San Cayetano', 'Santiago', 'Santo Domingo de Silos', 'Sardinata', 'Teorama', 'Tibú', 'Toledo', 'Villa Caro', 'Villa del Rosario'] },
        { code: 'PUT', name: 'Putumayo', cities: ['Colón', 'Mocoa', 'Orito', 'Puerto Asís', 'Puerto Caicedo', 'Puerto Guzmán', 'Puerto Leguízamo', 'San Francisco', 'San Miguel', 'Santiago', 'Sibundoy', 'Valle del Guamuez', 'Villagarzón'] },
        { code: 'QUI', name: 'Quindío', cities: ['Armenia', 'Buenavista', 'Calarcá', 'Circasia', 'Córdoba', 'Filandia', 'Génova', 'La Tebaida', 'Montenegro', 'Pijao', 'Quimbaya', 'Salento'] },
        { code: 'RIS', name: 'Risaralda', cities: ['Apía', 'Balboa', 'Belén de Umbría', 'Dosquebradas', 'Guática', 'La Celia', 'La Virginia', 'Marsella', 'Mistrató', 'Pereira', 'Pueblo Rico', 'Quinchía', 'Santa Rosa de Cabal', 'Santuario', 'Marambá'] },
        { code: 'SAP', name: 'San Andrés y Providencia', cities: ['Providencia y Santa Catalina Islas', 'San Andrés'] },
        { code: 'SAN', name: 'Santander', cities: ['Aguada', 'Albania', 'Aratoca', 'Barbosa', 'Barichara', 'Barrancabermeja', 'Betulia', 'Bolívar', 'Bucaramanga', 'Cabrera', 'California', 'Capitanejo', 'Carcasí', 'Cepitá', 'Cerrito', 'Charalá', 'Charta', 'Chima', 'Chipatá', 'Cimitarra', 'Concepción', 'Confines', 'Contratación', 'Coromoro', 'Curití', 'El Carmen de Chucurí', 'El Guacamayo', 'El Peñón', 'El Playón', 'El Socorro', 'Encino', 'Enciso', 'Florián', 'Floridablanca', 'Galán', 'Gámbita', 'Girón', 'Guaca', 'Guadalupe', 'Guapotá', 'Guavatá', 'Güepsa', 'Hato', 'Jesús María', 'Jordán', 'La Belleza', 'La Paz', 'Landázuri', 'Lebrija', 'Los Santos', 'Macaravita', 'Málaga', 'Matanza', 'Mogotes', 'Molagavita', 'Ocamonte', 'Oiba', 'Onzaga', 'Palmar', 'Palmas del Socorro', 'Páramo', 'Piedecuesta', 'Pinchote', 'Puente Nacional', 'Puerto Parra', 'Puerto Wilches', 'Rionegro', 'Sabana de Torres', 'San Andrés', 'San Benito', 'San Gil', 'San Joaquín', 'San José de Miranda', 'San Miguel', 'San Vicente de Chucurí', 'Santa Bárbara', 'Santa Helena del Opón', 'Simacota', 'Suaita', 'Sucre', 'Suratá', 'Tona', 'Valle de San José', 'Vélez', 'Vetas', 'Villanueva', 'Zapatoca'] },
        { code: 'SUC', name: 'Sucre', cities: ['Buenavista', 'Caimito', 'Chalán', 'Colosó', 'Corozal', 'Coveñas', 'El Roble', 'Galeras', 'Guaranda', 'La Unión', 'Los Palmitos', 'Majagual', 'Morroa', 'Ovejas', 'Sampués', 'San Antonio de Palmito', 'San Benito Abad', 'San Juan de Betulia', 'San Marcos', 'San Onofre', 'San Pedro', 'Sincé', 'Sincelejo', 'Sucre', 'Tolú', 'Tolú Viejo'] },
        { code: 'TOL', name: 'Tolima', cities: ['Alpujarra', 'Alvarado', 'Ambalema', 'Anzoátegui', 'Armero', 'Ataco', 'Cajamarca', 'Carmen de Apicalá', 'Casabianca', 'Chaparral', 'Coello', 'Coyaima', 'Cunday', 'Dolores', 'El Espinal', 'Falán', 'Flandes', 'Fresno', 'Guamo', 'Herveo', 'Honda', 'Ibagué', 'Icononzo', 'Lérida', 'Líbano', 'Mariquita', 'Melgar', 'Murillo', 'Natagaima', 'Ortega', 'Palocabildo', 'Piedras', 'Planadas', 'Prado', 'Purificación', 'Rioblanco', 'Roncesvalles', 'Rovira', 'Saldaña', 'San Antonio', 'San Luis', 'Santa Isabel', 'Suárez', 'Valle de San Juan', 'Venadillo', 'Villahermosa', 'Villarrica'] },
        { code: 'VAL', name: 'Valle del Cauca', cities: ['Alcalá', 'Andalucía', 'Ansermanuevo', 'Argelia', 'Bolívar', 'Buenaventura', 'Buga', 'Bugalagrande', 'Caicedonia', 'Cali', 'Calima', 'Candelaria', 'Cartago', 'Dagua', 'El Águila', 'El Cairo', 'El Cerrito', 'El Dovio', 'Florida', 'Ginebra', 'Guacarí', 'Jamundí', 'La Cumbre', 'La Unión', 'La Victoria', 'Obando', 'Palmira', 'Pradera', 'Restrepo', 'Riofrío', 'Roldanillo', 'San Pedro', 'Sevilla', 'Toro', 'Trujillo', 'Tuluá', 'Ulloa', 'Versalles', 'Vijes', 'Yotoco', 'Yumbo', 'Zarzal'] },
        { code: 'VAU', name: 'Vaupés', cities: ['Carurú', 'Mitú', 'Taraira', 'Pacoa', 'Papunaua', 'Yavaraté'] },
        { code: 'VID', name: 'Vichada', cities: ['Cumaribo', 'La Primavera', 'Puerto Carreño', 'Santa Rosalía'] },
      ],
      supervisorModulesList: [
        { id: 'usuarios', name: 'Usuarios' },
        { id: 'modelo', name: 'Modelo' },
        { id: 'produccion', name: 'Producción' },
        { id: 'operaciones', name: 'Operaciones' },
        { id: 'inventario', name: 'Inventario' },
        { id: 'insumos', name: 'Insumos' },
        { id: 'compras', name: 'Compras' },
        { id: 'remisiones', name: 'Remisiones' },
        { id: 'nomina', name: 'Nómina' },
      ],
    };
  },
  components: { ArgonInput, ArgonButton, ArgonCheckbox },
  computed: {
    isSupervisor() {
      return this.user.role === '2' || this.user.role === 2;
    },
    availableCities() {
      if (!this.user.province) return [];
      const dept = this.departments.find(d => d.name === this.user.province);
      return dept ? dept.cities : [];
    },
  },
  methods: {
    async getOficios() {
      this.processes = await this.$store.dispatch('users/getOficios');
    },
    onProvinceChange() {
      this.user.city = '';
    },
    async save() {
      // Evitar doble guardado
      if (this.isSaving) {
        return;
      }

      try {
        // Activar estado de guardado
        this.isSaving = true;

        // Mostrar modal de carga
        Swal.fire({
          title: 'Guardando...',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("users/save", this.user);
        
        // Cerrar modal de carga
        Swal.close();

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El usuario ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.$router.push({ name: 'Users' });
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el usuario');
        }
      } catch (error) {
        // Cerrar modal de carga en caso de error
        Swal.close();
        console.error("Error al crear el usuario:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el usuario',
        });
      } finally {
        // Desactivar estado de guardado
        this.isSaving = false;
      }
    }
  },
  mounted() {

    this.getOficios();

    const route = useRoute();
    const data = route.params.user;

    this.$nextTick(() => {
      $(this.$refs.processesSelect).select2();

      $(this.$refs.processesSelect).on('change', (event) => {
        this.user.processes = JSON.stringify($(event.target).val());
      });
    });

    if (data) {
      try {
        const params = JSON.parse(data); // Asegúrate de que este JSON se pueda parsear

        // Verifica si params contiene los datos de user
        if (params && params.id) {
          // Llena los campos del formulario con los datos del usuario
          this.user = params;
          this.user.id = params.id || 0;
          this.user.name = params.name || '';
          this.user.document_type = params.document_type || '';
          this.user.document = params.document || '';
          this.user.address = params.address || '';
          this.user.email = params.email || '';
          this.user.role = params.role || '1';
          this.user.status = params.status || '1';
          this.user.phone = params.phone || '';
          this.user.payment = params.payment || 0;
          this.user.processes = JSON.parse(params.processes || '[]') || [];
          if (params.supervisor_modules !== undefined && params.supervisor_modules !== null) {
            this.user.supervisor_modules = Array.isArray(params.supervisor_modules)
              ? [...params.supervisor_modules]
              : (typeof params.supervisor_modules === 'string' ? (params.supervisor_modules ? JSON.parse(params.supervisor_modules) : []) : []);
          } else {
            this.user.supervisor_modules = [];
          }
          if (this.$refs.processesSelect) {
            $(this.$refs.processesSelect).val(this.user.processes).trigger('change');
          }
        }
      } catch (error) {
        console.error("Error al parsear los datos del usuario:", error);
      }
    }

    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>
